import { useEffect, useState } from "react";
import { X } from "lucide-react";

// Space covered by the on-screen keyboard (Android/iOS), so the chat can sit above it
const useKeyboardInset = (active) => {
  const [inset, setInset] = useState(0);
  useEffect(() => {
    const vv = window.visualViewport;
    if (!active || !vv) return undefined;
    const update = () => {
      const kb = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
      setInset(kb > 80 ? kb : 0);
      if (kb > 80 && document.activeElement?.tagName === "INPUT") document.activeElement.scrollIntoView({ block: "end" });
    };
    update();
    vv.addEventListener("resize", update);
    vv.addEventListener("scroll", update);
    return () => { vv.removeEventListener("resize", update); vv.removeEventListener("scroll", update); setInset(0); };
  }, [active]);
  return inset;
};

export const ChatWindow = ({ t, open, onClose, children }) => {
  const inset = useKeyboardInset(open);
  if (!open) return null;
  return (
    <div data-testid="chat-window" style={inset ? { bottom: inset + 8, top: Math.max(8, 80 - inset) } : undefined}
      className="fade-up fixed inset-x-2 bottom-2 top-20 z-40 flex flex-col overflow-hidden rounded-3xl border border-slate-200 bg-white p-5 shadow-2xl sm:inset-x-auto sm:right-6 sm:top-24 sm:bottom-6 sm:w-[420px]">
      <button data-testid="chat-close-btn" onClick={onClose} aria-label={t("close")}
        className="absolute right-4 top-4 z-10 grid h-8 w-8 place-items-center rounded-full text-slate-400 hover:bg-slate-100 hover:text-slate-700"><X size={17} /></button>
      <div className="min-h-0 flex-1">{children}</div>
    </div>
  );
};
